<div id="mySidenav" class="sidenav" [class.pinned]="isPinned">

  <div class="emblem">
    <img src="assets/tcs-logo.png" alt="tcs-emblem" width="40" height="40" id="emblem" />
    <span class="tcs-emblem-text">Online TCS</span>
  </div>

  <!-- Search input or icon based on sidebar pinned state -->
  <div class="search-container" [ngClass]="{ pinned: isPinned }">

    <ng-container *ngIf="isPinned; else searchIconOnly">
      <input type="text" placeholder="Search menu..." class="search-input" [(ngModel)]="searchText"
        (ngModelChange)="filterSidebarItems($event)" />
    </ng-container>

    <ng-template #searchIconOnly>
      <div class="search-icon-wrapper" title="" style="padding-left: 10px; padding-top: 25px;" (click)="openSearch()">
        <span class="material-icons">search</span>
      </div>
    </ng-template>

  </div>

  <div class="drawer">


    <div class="parent" *ngFor="let item of filteredSidebarItems; let i = index"
      [attr.expanded]="expandedItems[i] ? 'true' : 'false'" [attr.active]="checkActive(window.location.pathname, item)"
      (mouseenter)="hoverOnSide($event, i)" (mouseleave)="leaveOnSide($event, i)">

      <div class="maintitle" (click)="click(i,item.GroupName)">
        <!-- <div class="icon" [inlineSVG]="item.MenuIconURL"></div> -->
        <img class="icon"  [src]="item.MenuIconURL" alt="">
        <span class="sidenav-title" [innerHTML]="highlightMatch(item.GroupName)"></span>
      </div>

      <!-- Show submenus only if parent is expanded -->
      <div class="anchor-group" *ngIf="expandedItems[i]">

        <a *ngFor="let sub of item.SubMenus" class="subtitle" [routerLink]="sub.MenuURL"
          routerLinkActive="active-submenu" 
          (click)="handleClick(sub.MenuURL,sub.PrivilegeName)" [innerHTML]="highlightMatch(sub.PrivilegeName)">
        </a>

      </div>

    </div>

  </div>

</div>